import { LinkInfo, PagingHeader } from "../shared/shared.model";

export class DataOutputModel {
    Paging: PagingHeader;
    Links: LinkInfo[];
    Items: Opdata[];
}

export interface Opdata {
Id:number;
Valid:number;
TrainId:number;
Datetime:string;
Ph:number;
Temp:number;
S1ConcFlow:number;
S1PermFlow:number;
S1FeedPress:number;
S1ConcPress:number;
S1PermPress:number;
S1FeedCond:number;
S1PermCond:number;
S2ConcFlow:number;
S2PermFlow:number;
S2FeedPress:number;
S2ConcPress:number;
S2PermPress:number;
S2FeedCond:number;
S2PermCond:number;
S3ConcFlow:number;
S3PermFlow:number;
S3FeedPress:number;
S3ConcPress:number;
S3PermPress:number;
S3FeedCond:number;
S3PermCond:number;
Ud1:number;
Ud2:number;
Ud3:number;
Ud4:number;
Ud5:number;
Comments:string;
CreatedAt: string;
UpdatedAt: string;
UserId:number;
Actiontype:string;
AspNetUsersId: string;
}

export class RawOpdata {
    Id:number;
    Valid:number;
    TrainId:number;
    Datetime:string;
    Ph:number;
    Temp:number;
    S1ConcFlow:number;
    S1PermFlow:number;
    S1FeedPress:number;
    S1ConcPress:number;
    S1PermPress:number;
    S1FeedCond:number;
    S1PermCond:number;
    S2concflow:number;
    S2permflow:number;
    S2feedpress:number;
    S2concpress:number;
    S2permpress:number;
    S2feedcond:number;
    S2permcond:number;
    S3concflow:number;
    S3permflow:number;
    S3feedpress:number;
    S3concpress:number;
    S3permpress:number;
    S3feedcond:number;
    S3permcond:number;
    Ud1:number;
    Ud2:number;
    Ud3:number;
    Ud4:number;
    Ud5:number;
    Comments:string;
    CreatedAt: string;
    UpdatedAt: string;
    UserId:number;
    Actiontype:string;
    AspNetUsersId: string="";
   }

  